import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-circle-percent-marker',
  templateUrl: './circle-percent-marker.component.html',
  styleUrl: './circle-percent-marker.component.css'
})
export class CirclePercentMarkerComponent
{
  @Input() title : string;
  @Input() time : number;
}
